export class CartOrderFormViewModel {
    public contact: string;
    public phone: string;
    public reference: string;
    public comments: string;

    constructor() {
        this.contact = '';
        this.phone = '';
        this.reference = '';
        this.comments = '';
    }
}
